import { Typography, useMediaQuery } from '@mui/material'
import { Box } from '@mui/system'
import React, { useState } from 'react'
import { Else, If, Then } from 'react-if'
import FAIcon from 'Theme/FAIcon'
import { FA_ICONS } from 'Theme/font-awesome-icon-constants'

import Button from '../../../../../Theme/Button'
import CustomModal from '../../../../../Theme/Modal'
import { BREAKPOINT_MIN_SM } from '../../../../../Theme/stylesUtil'
import { MapCard } from '../../../../_common/CollectionCard/MapCard'
import MainSwipableDrawer from '../../../../Mobile/MainSwipableDrawer'
import ContestInvitationMapsComponent from '../../../InvitationSteps/ContestInvitationMapsComponent'

export const FavoriteOriginal = ({ favoriteMaps, saveMapCardToFav, deleteMapCardFromFav, isOriginal }) => {
  const [openMaps, setOpenMaps] = useState(false)

  const handleCloseMaps = () => {
    setOpenMaps(false)
  }
  const handleShowMaps = () => {
    setOpenMaps(true)
  }
  const isBiggerThanSMScreen = useMediaQuery(BREAKPOINT_MIN_SM)
  const gridTemplateColumns = !isBiggerThanSMScreen ? '1fr' : isOriginal ? '1fr 1fr 1fr' : '1fr 1fr'
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography
          variant="h6"
          color={'text.secondary'}
          padding={'12px 0'}
        >
          <If condition={isOriginal}>
            <Then>3 Favorite Original Halo map</Then>
            <Else>4 Favorite Forge maps</Else>
          </If>
        </Typography>
        <Typography
          variant="h6"
          color={'text.secondary'}
          padding={'12px 0'}
        >
          {favoriteMaps.length}/{isOriginal ? 3 : 4}
        </Typography>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        gap={1}
      >
        <Box
          display="flex"
          gap={1}
        >
          <Button
            color="inherit"
            endIcon={<FAIcon iconClassName={FA_ICONS.HISTORY} />}
            onClick={handleShowMaps}
            sx={{ width: '100%' }}
          >
            Select Map
          </Button>
        </Box>
        <Box sx={{ display: 'grid', gridTemplateColumns, gap: '15px' }}>
          {favoriteMaps.map((map) => (
            <MapCard
              key={map.id}
              map={map}
              style={{ height: '192px' }}
            />
          ))}
        </Box>
      </Box>
      <If condition={isBiggerThanSMScreen}>
        <Then>
          <Box width={'100vw'}>
            <CustomModal
              open={openMaps}
              onClose={handleCloseMaps}
              fullWidth={true}
              modalPadding={'56px'}
            >
              <ContestInvitationMapsComponent
                favoriteMaps={favoriteMaps}
                errors={''}
                saveMapCardToFav={saveMapCardToFav}
                deleteMapCardFromFav={deleteMapCardFromFav}
                isOriginal={isOriginal}
              />
            </CustomModal>
          </Box>
        </Then>
        <Else>
          <MainSwipableDrawer
            isOpenDrawer={openMaps}
            setIsOpenDrawer={setOpenMaps}
            drawerHeight={'75vh'}
          >
            <ContestInvitationMapsComponent
              favoriteMaps={favoriteMaps}
              errors={''}
              saveMapCardToFav={saveMapCardToFav}
              deleteMapCardFromFav={deleteMapCardFromFav}
              isOriginal={isOriginal}
            />
          </MainSwipableDrawer>
        </Else>
      </If>
    </Box>
  )
}
